import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SelectControl } from '@/components/form-controls'
import { useDocumentTypes } from '@/hooks'

interface DocumentTypeControlProps {
    control: Control<any>
    isDisabled: boolean
}

export const DocumentTypeControl = ({
    control,
    isDisabled
}: DocumentTypeControlProps): JSX.Element => {
    const { t } = useTranslation()
    const { documentTypes, isLoading, hasError } = useDocumentTypes()

    if (isLoading) {
        return (
            <div className="flex items-center justify-center p-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <span className="ml-2 text-gray-600">{t('Cargando')}...</span>
            </div>
        )
    }

    if (hasError) {
        return (
            <div className="text-red-600 text-center p-4">
                <p>{t('Error al cargar tipos de documento')}</p>
                <p className="text-sm text-gray-500 mt-1">
                    {t('Por favor, inténtalo de nuevo más tarde')}
                </p>
            </div>
        )
    }

    return (
        <SelectControl
            control={control}
            name="idDocumentType"
            label={t('Tipo de documento')}
            options={documentTypes}
            isDisabled={isDisabled}
            placeholder={t('Selecciona un tipo de documento')}
            rules={{
                required: t('forms.common.required.documentType')
            }}
        />
    )
}
